// Two-tone chime played when a chat message arrives.
//
// One AudioContext is reused for the life of the page. Creating one per message
// leaks: browsers cap the number of live contexts and stop honouring new ones,
// so a long chat would fall silent partway through.
let ctx: AudioContext | null = null;

function audioContext(): AudioContext | null {
  if (ctx) return ctx;
  const Ctor = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  ctx = new Ctor();
  return ctx;
}

export function playNotificationSound(): void {
  try {
    const audio = audioContext();
    if (!audio) return;

    // Autoplay policy leaves the context suspended until the first user gesture.
    // By the time a message arrives the user has clicked to open the chat, so a
    // resume here is enough; failure is not worth surfacing.
    if (audio.state === 'suspended') void audio.resume();

    const oscillator = audio.createOscillator();
    const gain = audio.createGain();
    oscillator.connect(gain);
    gain.connect(audio.destination);
    oscillator.frequency.setValueAtTime(880, audio.currentTime);
    oscillator.frequency.setValueAtTime(1100, audio.currentTime + 0.1);
    gain.gain.setValueAtTime(0.3, audio.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, audio.currentTime + 0.3);
    oscillator.start(audio.currentTime);
    oscillator.stop(audio.currentTime + 0.3);
  } catch {
    // Audio is a nicety; never let it break message rendering.
  }
}
